import { css } from '@emotion/core';
import { Icon, Input } from 'antd';
import { debounce } from 'lodash';
import React, { useState } from 'react';

import { bp } from '@/styles';

const styles = {
  searchInput: css`
    width: 165px;
    margin-right: 12px;
    // margin-left: 50px;
    @media ${bp.sm} {
      width: 200px;
      margin-left: 0;
    }
    @media ${bp.md} {
      width: 249px;
    }
  `,
  clearSearchIcon: css`
    color: #aaa;
    &:hover {
      color: #373737;
    }
  `,
};

const SearchBar = ({ returnSearchTerm }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const debounceSearch = debounce(returnSearchTerm, 350);

  return (
    <Input
      css={styles.searchInput}
      size="medium"
      value={searchTerm}
      prefix={<Icon type="search" />}
      suffix={
        <Icon
          css={styles.clearSearchIcon}
          // style={{ color: "#aaa" }}
          type="close-circle"
          onClick={() => {
            setSearchTerm('');
            returnSearchTerm('');
          }}
        />
      }
      placeholder="Jump to…"
      // autoComplete="off"
      onChange={e => {
        setSearchTerm(e.target.value);
        // returnSearchTerm(e.target.value);
        debounceSearch(e.target.value);
      }}
    />
  );
};

export default SearchBar;
